"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
    }
    LocalStorage.setItem = function (key, item) {
        localStorage.setItem(key, JSON.stringify(item));
    };
    LocalStorage.getItem = function (key) {
        var item = localStorage.getItem(key);
        if (item === null) {
            return null;
        }
        return JSON.parse(item);
    };
    LocalStorage.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    return LocalStorage;
}());
exports.default = LocalStorage;
